import React from "react";
import { Link } from "react-router-dom";
import VideoBehindText from "../components/video-image-background/video-behind-text.component";
import eventData from "../data/event-data";
// import EventCard from "../components/general/event-card-component";

type bigLinkProps = {
   wide?: boolean,
   anchor?: boolean,
   to: string,
   text: string,
}

const BigLink: React.FC<bigLinkProps> = ({ wide, to, text, anchor }) => {
   let className = "";
   className += "max-w-full text-center rounded-md m-1 ";
   className += "p-1 text-sm ";
   className += "sm:p-2 sm:text-lg ";
   className += "lg:p-4 lg:text-2xl ";
   className += "bg-gray-200 text-gray-900 ";
   className += "hover:bg-gray-800 hover:text-gray-100 ";

   return (
      <div className={(wide ? ' col-span-3' : '')}>
         { anchor
            ?
            <div className={className}>
               <a target="_blank" href={to} rel="noreferrer">{text}</a>
            </div>
            :
            <Link to={to}>
               <div className={className}>
                  {text}
               </div>
            </Link>
         }

      </div>
   )
};


const HomePage = () => (
   <VideoBehindText mainText="Ethan David Loch" subText="Piano and Composition" video url="banner2.mp4">
      <div className="grid grid-cols-3 w-full object-center">
         <BigLink to="/events" text="Events" wide></BigLink>
         <BigLink to="/saturday" text="Saturday Concerts" wide></BigLink>
         <BigLink to="/radio" text="Radio"></BigLink>
         <BigLink to="/bio" text="Biography"></BigLink>
         <BigLink to="/videos" text="Video Gallery"></BigLink>
         <BigLink to="/photos" text="Photo Gallery"></BigLink>
         <BigLink to="/support" text="Support"></BigLink>
         <BigLink to="/contact" text="Contact"></BigLink>
         <BigLink to="mpv1/index.html" text="Mysterious Pathways Volume One" anchor wide></BigLink>
         <BigLink to="https://amazon.co.uk/music/player/albums/B08R2SVFRX?marketplaceId=A1F83G8C2ARO7P&musicTerritory=GB&ref=dm_sh_hecPz58xYufaq18la3uPLM9bK" text="Mysterious Improvisations 2020" anchor wide></BigLink>
      </div>
      <div className="events">
      {
         // eventData.map(event => <EventCard {...event} />)
      }
      </div>
   
   </VideoBehindText>
);

export default HomePage;